module.exports = __webpack_public_path__ + "img/icon-market-report.f7f12f73.png";